import { Locale, type LocalizedString } from "../Locale.js";
import { WeddingCakeLayers } from "../WeddingCakeLayers.js";

export const weddingCakeLayersNameMap = {
	[WeddingCakeLayers.OneLayer]: { [Locale.cs]: "1 patro" },
	[WeddingCakeLayers.TwoLayers]: { [Locale.cs]: "2 patra" },
	[WeddingCakeLayers.ThreeLayers]: { [Locale.cs]: "3 patra" },
	[WeddingCakeLayers.More]: { [Locale.cs]: "Více" },
} satisfies Record<WeddingCakeLayers, LocalizedString>;
